<div class="optForm-container">
  <form (ngSubmit)="onSubmit()" [formGroup]="fgroup">
    <div class="form-container">
      <!--prefix and opt placeholder-->
      <div class="prefixAndOptInputBox-container" formArrayName="otpArr">
        <h1 class="prefixLabel">{{ otpPrefix }}</h1>
        <input type="text" id="otpInput-{{i}}" pattern="[0-9]*" digitOnly min="0" max="9" inputmode="numeric"
          [ngClass]="{'otpInput': (i+1) === otpArrs.controls.length}" #formotpArr
          *ngFor="let _ of otpArrs.controls; index as i" [formControlName]="i" (input)="onOtpInput($event, i)"
          (keydown)="onOtpKeydown($event, i)" (click)="onOtpFocus($event, i)">
      </div>

      <div class="invalid-feeback"
        *ngIf="(verifyOTPError && verifyOTPError.error.errorCode === ErrorCode.InvalidOTP) || invalidOTPError">
        {{ 'error.invalid.otp' | translate}}
      </div>

      <!--resend button && time && skip otp button-->
      <div class="resend-timer-btn" *ngIf="!showOptions && !hideTimer">
        <!-- before 3 times -->
        <h1>{{'otp.resend.otp.in' | translate}}</h1>
        <app-timer [timeInSec]="timeInSec" (onCallback)="onTimerCallback($event)"
          (onShowBackButton)="onShowBackButton($event)">
        </app-timer>
      </div>

      <div class="otp-resend-via" *ngIf="showOptions && !isSignUpForm">
        <!-- after 3 times with acc -->
        <h1>{{'desc.didnt.receive.otp' | translate}} <span>{{'desc.resend.via' | translate}}</span></h1>
        <div class="resend-method">
          <span class="method" (click)="onSendOTP(true)">{{'otp.method.sms' | translate}}</span>
          <span *ngIf="userVerifiedEmail !== ''">{{'label.or' | translate}}</span>
          <span class="method" *ngIf="userVerifiedEmail !== ''" (click)="sendOtpEmail()">{{ 'label.email' |
            translate }}</span>
        </div>
      </div>

      <div class="otp-resend-via"  *ngIf="isSignUpForm && hideTimer">
        {{'desc.didnt.receive.otp' | translate}}
      </div>

      <!-- after 3 times without acc -->
      <div class="otp-resend-via-withoutAcc" *ngIf="showOptions && isSignUpForm && numberOfTimeResend <= 0">
        <app-button [blackTextButton]="true" [buttonName]="'button.resend' | translate"
          (onClickEvent)="onSendOTP(true)"></app-button>
        <span>{{'label.or' | translate}}</span>
        <app-button [blackTextButton]="true" [buttonName]="'button.skip' | translate"
          (onClickEvent)="skipOtp()"></app-button>
      </div>

      <app-button [blackTextButton]="true" [buttonName]="'button.send.via.email' | translate" (onClickEvent)="sendOtpEmail()"
        class="email-resend-btn" *ngIf="!showOptions && !isSignUpForm && userVerifiedEmail !== ''"></app-button>

      <app-button [blackTextButton]="true"
        [buttonName]="'label.number.of.resend' | translate : { number: numberOfTimeResend }"
        (onClickEvent)="manualResendOTP()" class="resend-counter-btn" *ngIf="showOptions && isSignUpForm &&
        (numberOfTimeRefresh > 0) && (numberOfTimeResend > 0) && hideTimer"></app-button>

      <app-button [buttonName]="'button.verify' | translate" (onClickEvent)="onSubmit()"
        class="verify-btn" [disabled]="validLength !== 6"></app-button>
    </div>
  </form>
</div>
